import { render } from "./MobileApplication.vue?vue&type=template&id=5236f83a&scoped=true"
import script from "./MobileApplication.vue?vue&type=script&lang=js"
export * from "./MobileApplication.vue?vue&type=script&lang=js"

import "./MobileApplication.vue?vue&type=style&index=0&id=5236f83a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5236f83a"]])

export default __exports__